import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FaChevronRight } from "react-icons/fa";
import Image from "react-bootstrap/Image";
import "./Praise.css";

function Praise({
  id,
  title,
  receiverName,
  receiverProfilePicture,
  senderId,
  senderName,
  senderProfilePicture,
  message,
  values,
  createdAt,
  userId,
  handleShow,
  language,
}) {
  const { t } = useTranslation();

  const dayjs = require("dayjs");

  return (
    <Col lg={4}>
      <Col className="praise-card">
        {senderId === userId ? (
          <Col className="praise-options">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faCog} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleShow(id)}>
                  <FontAwesomeIcon icon={faTrash} />{" "}
                  {t("Reconocimientos.Reconocimiento.Eliminar")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        ) : (
          <></>
        )}
        <Col>
          <h4 className="praise-title">{title}</h4>
          <Image
            src={senderProfilePicture}
            roundedCircle
            fluid
            style={{ maxWidth: 70 }}
          />
          <FaChevronRight
            style={{
              fontSize: 30,
              color: "#555",
              marginLeft: 10,
              marginRight: 10,
            }}
          />
          <Image
            src={receiverProfilePicture}
            roundedCircle
            fluid
            style={{ maxWidth: 70 }}
          />
          <Col className="praise-values-badges">
            {values.map((value) => (
              <span key={value._id} className="praise-value-badge">
                {language === "es" ? value.title : value.titleEnglish}
              </span>
            ))}
          </Col>

          <hr />
          <p className="praise-date">{dayjs(createdAt).format("DD/MM/YYYY")}</p>
          <h6 className="praise-stakeholders">
            {t("Reconocimientos.Reconocimiento.De")} {senderName}
          </h6>
          <h6 className="praise-stakeholders">
            {t("Reconocimientos.Reconocimiento.Para")} {receiverName}
          </h6>
          <p className="praise-message">{message}</p>
        </Col>
      </Col>
    </Col>
  );
}

export default Praise;
